<template>
	<div>
		<AppTag v-if="viewTag==1" />
		<el-container direction="vertical">
		<el-main>
			<router-view v-if="isRefash"></router-view>															
		</el-main>	
		<el-footer height="25px" v-if="viewFooter==1">
			<div>{{title}} </div>
		</el-footer>
		</el-container>					
	</div>
</template>

<script>
	import AppTag from "./AppTag.vue"
	import store from '../../store'
	export default {
		components: {
			AppTag,
		},
		data() {
			return {
				isRefash: true,
				title :store.state.menuModule.logoInfo.title
			};
		},
		computed: {
			viewTag() {
				return store.state.settings.theme.viewTag;
			},
			viewFooter() {
				return store.state.settings.theme.viewFooter;
			},
		},
		methods: {
			reload() { //通过控制路由显示刷新当前页面
				this.isRefash = false;
				this.$nextTick(() => {
					this.isRefash = true;
				})
			}
		}
	}
</script>

<style lang='less' scoped>
	.app-wrapper {
		position: relative;
		height: 100%;
		width: 100%;

		&.mobile.openSidebar {
			position: fixed;
			top: 0;
		}
	}
    .el-container{
		height: calc(100vh - 6rem);		
		.el-main {
			margin: 8px 8px 8px 8px;
			border-radius: 5px;
			background-color: #fff;
			height:0;
			flex-grow:1;
			overflow-x: hidden;					
		}
		.el-footer {
			text-align: center;
			bottom: 0;	
			color: #000;
			height: 8px;
		}	
	}			
	.hideSidebar .fixed-header {
		width: calc(100% - 54px)
	}

	.mobile .fixed-header {
		width: 100%;
	}

</style>